/* eslint-disable */
import api from '@/utils/backend-api'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    Notifications: [],
    NextNotificationUrl:''
  },
  mutations: {
    setNotificationData (state, Notifications) {
      state.Notifications = Notifications
    },
    setNextNotificationUrl(state, url) {
      state.NextNotificationUrl = url
    },
    pushNotificationData (state, Notifications) {
      let newNotifications=state.Notifications.concat(Notifications)
      state.Notifications=newNotifications
    },
    reset (state) {
      state.Notifications = []
    }
  },
  actions: {
    getAllNotifications ({commit}) {
      return new Promise(function (resolve, reject) {
        api.getData('admin/notification')
        .then((response) => {
          var Notifications = response.data.data
          let url=response.data.next_page_url
          commit('setNotificationData', Notifications)
          commit('setNextNotificationUrl', url)
          resolve(Notifications)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    callNextNotifications({commit,state}){
      let url=state.NextNotificationUrl
      let config={
        headers:{
          'Authorization': 'Bearer '+Store.state.token
        }
      }
      axios.get(url,config)
      .then((response) => {
        var Notifications = response.data.data
        let url=response.data.next_page_url
        commit('setNextNotificationUrl', url)
        commit('pushNotificationData', Notifications)
      }).catch((error) => {
      })
    },
     pushLiveNotification({commit,state},data){
        let notification={
            date: JSON.parse(data.created_at).date.substring(0,19),
            from_user_id: '',
            id: '',
            message: data.notification_message,
            opposite_user_id: '',
            time: '',
            type: '1',
            user_id: data.admin_id?data.admin_id:'',
            user_image: data.user_image,
            user_name: data.user_name,

        }
        state.Notifications.unshift(notification)
        // commit('pushNotificationData', Notifications)
      
     }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Notifications.js